/**
 * Controller registration, cursor.
 */
AFRAME.registerComponent('controller', {
  schema: {
    hand: {default: 'right', oneOf: ['left', 'right']}
  },

  init: function () {
    const el = this.el;
    const data = this.data;

    this.controllerType = '';

    el.addEventListener('controllerconnected', evt => {
      this.controllerType = evt.detail.name;
      this.el.setAttribute('cursor', this.config[this.controllerType].cursor || {});
    });

    const hand = {hand: data.hand, model: false};
    el.setAttribute('daydream-controls', hand);
    el.setAttribute('oculus-go-controls', hand);
    el.setAttribute('oculus-touch-controls', {
      hand: data.hand,
      model: false,
      orientationOffset: {x: 0, y: 0, z: 0}
    });
    el.setAttribute('vive-controls', hand);
    el.setAttribute('vive-focus-controls', hand);
    el.setAttribute('windows-motion-controls', hand);
    el.setAttribute('generic-tracked-controller-controls', hand);
  },

  config: {
    'daydream-controls': {
      cursor: {
        downEvents: ['trackpaddown', 'triggerdown'],
        upEvents: ['trackpadup', 'triggerup']
      }
    },

    'oculus-go-controls': {
      cursor: {
        downEvents: ['trackpaddown', 'triggerdown'],
        upEvents: ['trackpadup', 'triggerup']
      }
    },

    'oculus-touch-controls': {
      cursor: {
        downEvents: [
          'triggerdown',
          'gripdown',
          'abuttondown',
          'bbuttondown',
          'xbuttondown',
          'ybuttondown'
        ],
        upEvents: [
          'triggerup',
          'gripup',
          'abuttonup',
          'bbuttonup',
          'xbuttonup',
          'ybuttonup'
        ]
      }
    },

    'vive-controls': {
      cursor: {
        downEvents: ['trackpaddown', 'triggerdown', 'gripdown'],
        upEvents: ['trackpadup', 'triggerup', 'gripup']
      }
    },

    'vive-focus-controls': {
      cursor: {
        downEvents: ['trackpaddown', 'triggerdown', 'gripdown'],
        upEvents: ['trackpadup', 'triggerup', 'gripup']
      }
    },

    'windows-motion-controls': {
      cursor: {
        downEvents: ['trackpaddown', 'triggerdown', 'gripdown'],
        upEvents: ['trackpadup', 'triggerup', 'gripup']
      }
    },

    'generic-tracked-controller-controls': {
      cursor: {
        downEvents: ['triggerdown'],
        upEvents: ['triggerup']
      }
    }
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['controller',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
